import { render, staticRenderFns } from "./courseDetailsAudio.vue?vue&type=template&id=0986d167&"
import script from "./courseDetailsAudio.vue?vue&type=script&lang=js&"
export * from "./courseDetailsAudio.vue?vue&type=script&lang=js&"
import style0 from "./courseDetailsAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports